import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export const EventType = {
	ENTRIES: 'entries',
	INCIDENTS: 'incidents',
};

export default {
    getExports(requestedForType, requestedForId) {
        return axios.get(
            API.url(Endpoints.Events.FetchExports, {
                requestedForType: requestedForType,
                requestedForId: requestedForId,
            })
        ).then((res) => {
            return res.data.exports
        })
    },

	getEvents(type, filters, maxResults) {

		if(!type) {
			type = EventType.ENTRIES;
		}

		let data = Object.assign({}, filters);

		if(maxResults) {
			data.max = maxResults;
		}

		return axios.post(
			API.url(Endpoints.Events.Fetch, {type: type}),
			data,
		).then((res) => {
			return {events: res.data.data, meta: res.data.meta};
		});

	},

	export(type, filters, maxResults) {

		let data = Object.assign({}, filters);

		if(maxResults) {
			data.max = maxResults;
		}

		return axios.post(
			API.url(Endpoints.Events.Export, {type: type}),
			data,
		).then((res) => {
			return res.data.export_url;
		});

	},

	getEventTypes(type) {

		return axios.get(
			API.url(Endpoints.Events.Types, {type: type}),
		).then((res) => {
			return res.data.types;
		});

	},

}
